<template>
<div v-if="renderGrid" :id="name+'Father'" class="jqx_grid_wrapper" style="position: relative">
    
    <div v-if="displayedTitle != null" v-html="displayedTitle"></div>
    <div :id="name"></div>

    <!-- POPUP EDITORS-->
    <!-- text -->
    <text-modifier v-if="textPopup" effect="fade" placement="left" 
    :popoverStyle="popoverStyle" 
    :arrowStyle="arrowStyle"
    :title="popupTitle"
    :content="popupContent" :popoverCondition="popoverCondition"
    :value="initialValue" :placeholder="this.$Jed.firstUpperTranslate('insert text')"
    :validation="validation"
    :fixedTop="topPos" :fixedLeft="leftPos"
    @confirm="editEndCallback">
        <span :id="guid" style="position: fixed;" :style="{left: leftPos + 'px', top: topPos + 'px'}"></span>
    </text-modifier>
    <!-- selection -->
    <selector-modifier v-if="selectionPopup" effect="fade" placement="right" 
    :choices="editSelectOptions" fieldValue="value" fieldLabel="label"
    :fixedTop="topPos" :fixedLeft="leftPos"
    title="Prova Popup Selector"
    content="Select generica"
    :validation="validation" :value="initialValue" placeholder="Scegli una delle opzioni"
    @confirm="editEndCallback">
        <span :id="guid" style="position: fixed;" :style="{left: leftPos + 'px', top: topPos + 'px'}"></span>
    </selector-modifier>
    <!-- number -->
    <number-modifier v-if="numberPopup" effect="fade" placement="right" 
    title="Prova Popup Number Editor"
    content="Popup generico per la modifica di un intero" 
    :fixedTop="topPos" :fixedLeft="leftPos"
    :value="initialValue" placeholder="Inserisci Numero Intero"
    :validation="validation"
    @confirm="editEndCallback">
        <span :id="guid" style="position: fixed;" :style="{left: leftPos + 'px', top: topPos + 'px'}"></span>
    </number-modifier>
    <!-- date -->
    <date-modifier v-if="datePopup" effect="fade" placement="right" 
    title="Prova Popup Date Editor"
    content="Popup generico per la modifica di un campo data"
    :fixedTop="topPos" :fixedLeft="leftPos"
    :value="initialValue"
    :validation="validation"
    @confirm="editEndCallback">
        <span :id="guid" style="position: fixed;" :style="{left: leftPos + 'px', top: topPos + 'px'}"></span>
    </date-modifier>

    <help-popover 
        :helpProp="name" :reference="name" :msg="helperMsg" 
        :offset="{top: -50}">
    </help-popover>
</div>
</template>
<script>
import { localizationMixin } from './localization.js'
import { eventBus } from "../../../eventbus.js"

import TextModifier from "../popoverWrapper/TextModifier.vue"
import SelectorModifier from "../popoverWrapper/SelectorModifier.vue"
import NumberModifier from "../popoverWrapper/NumberModifier.vue"
import DateModifier from "../popoverWrapper/DateModifier.vue"
import HelpPopover from "../HelpPopover.vue"

    export default {
        components: {
            TextModifier,
            SelectorModifier,
            NumberModifier,
            DateModifier,
            HelpPopover
        },
        mounted: function(){
            var vm = this;
            var mergeConfigs = this.$Components[this.name];
            // se da config la griglia non è visibile, non eseguo alcun codice
            if(!mergeConfigs || mergeConfigs.visible != false){
                var dis = mergeConfigs && mergeConfigs.title ? mergeConfigs.title : this.title;
                if(dis){
                    this.displayedTitle = this.$Jed.firstUpperTranslate(dis)
                }
                this.grid_configs.localization = this.getLocalization(this.lang);
                this.overrideGridConfigs();
                
                /* mergeThenParseColumns si preoccupa prima di effettuare un merge (se necessario) delle configurazioni delle colonne ...
                ... e in seguito di eseguire le trasformazioni standard del componente sull'Array risultante */
                
                var res = this.mergeThenParseColumns(this.columns.configs, this.source, this.name);
                this.mappedColumns = res.columns;
                this.datafields = res.datafields;
                if(this.others.adaptColumns){
                    this.columnsWidthAdjust();
                }
                this.initSource();
                this.grid = $("#"+this.name);
                $(window).resize(function() {
                    //chiamo la funzione di refresh per fixare il bug di resize della grid
                    vm.grid.jqxGrid('refresh');
                });    
            }
            //return filter API as event parameter
            this.$emit('API', {applyFilter: this.filterCommand, removeFilter: this.removeFilterCommand, redraw: this.forcedRedraw, getSelection: this.getSelectedRows});

            this.$on("ready", function(){
                var els = document.getElementsByClassName('jqx-grid-column-sortdescbutton jqx-grid-column-sortdescbutton-light jqx-icon-arrow-down jqx-icon-arrow-down-light')
                while (els[0]) {
                    els[0].classList.add('jqx-grid-sortdesc-icon')
                    els[0].classList.remove('jqx-grid-column-sortdescbutton', 'jqx-grid-column-sortdescbutton-light', 'jqx-icon-arrow-down', 'jqx-icon-arrow-down-light')
                }

                var els = document.getElementsByClassName('jqx-grid-column-sortascbutton jqx-grid-column-sortascbutton-light jqx-icon-arrow-up jqx-icon-arrow-up-light')
                while (els[0]) {
                    els[0].classList.add('jqx-grid-sortasc-icon')
                    els[0].classList.remove('jqx-grid-column-sortascbutton', 'jqx-grid-column-sortascbutton-light', 'jqx-icon-arrow-up', 'jqx-icon-arrow-up-light')
                }
            })
            //window.addEventListener("scrollMutation", vm.scrollWorkaround);
        },
        /* beforeDestroy:function(){
            var vm = this;
            window.removeEventListener("scrollMutation", vm.scrollWorkaround);
        }, */
        mixins: [localizationMixin],
        props: {
            name: String,
            source: Array,
            // columns deve avere un'unico campo configs
            // columns.configs può essere un Array o un Object
            columns: Object,
            // options configurabili: tutte le PROPERTIES (meno source e columns) definite per JQWGrid (https://www.jqwidgets.com/jquery-widgets-documentation/documentation/jqxgrid/jquery-grid-api.htm?search=)
            options: Object,
            lang: {
				type: String,
	            default: "en"
	        },
            sortby: String,
            title: String,
            others: {
                type: Object,
                default: function(){
                    return {}
                }
            },
            select: String,
            selectParameter: String,
            rowClick: {
                type: Function,
                default: function(obj, index){
                    this.grid.jqxGrid('clearselection');
                    this.grid.jqxGrid('selectrow', index);
                }
            },
            tableContent: String
        },
        created: function(){
            var vm = this;
            eventBus.$on("containerResize", function(){
                if(vm.grid){
                    vm.grid.jqxGrid('refresh');
                }
            })
        },
        watch: {
            options: function(){
                 this.overrideGridConfigs();
            },
            source: function(){
                /*
                this.sorgente.localdata = this.source;
               
                this.grid.jqxGrid('updatebounddata');   
                this.setupClickBehavior(this.name, this.mappedColumns, this.source);
                this.focusRows();
                */
                if(this.grid){
                    this.grid.jqxGrid('destroy');
                }
                var node = document.createElement("DIV");
                node.id = this.name;
                document.getElementById(this.name+"Father").appendChild(node); 
                this.initSource();
                this.setupClickBehavior(this.name, this.mappedColumns, this.source);
                this.grid = $("#"+this.name);
                var vm = this;
                $(window).resize(function() {
                    //chiamo la funzione di refresh per fixare il bug di resize della grid
                    vm.grid.jqxGrid('refresh');
                });    
            },
            select: function(){
                this.focusRows();
            },
            tableContent: function(msg){
                this.grid_configs.localization.emptydatastring = msg;
            }
        },
        data: function(){
            return {
                grid_configs: {
                    columnsresize: true,
                    columnsreorder: true,
                    rowsheight: 32,
                    rowdetails: false,
                    theme: 'glacier',
                    width: '100%',
                    selectionmode: 'none',
                    autoshowcolumnsmenubutton: false,
                    pageable: true,
                    showfilterrow: true,
                    filterable: true,
                    sortable: true,
                    autoheight: true,
                    rowdetailstemplate: {
                        rowdetails: "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
                        rowdetailsheight: 100
                    },
                    initrowdetails: null
                },
                sorgente: null,
                mappedColumns: [],
                datafields: [],
                active_row: null,

                // campi di supporto per l'editing
                initialValue: null,
                leftPos: null,
                topPos: null,
                guid: null,
                editEndCallback: null,
                editSelectOptions: null,
                textPopup: false,
                selectionPopup: false,
                numberPopup: false,
                datePopup: false,
                validation: null,
                popupTitle:'',
                popupContent:'',
                popoverCondition: false,
                popoverStyle: {'top':'0px','left':'1420px', 'max-width': '200px', width: '200px', 'font-size': 'small', height: 'max-content'},
                arrowStyle: {'top':'20%'},

                // campi sovrascrivibili da config
                displayedTitle: null,
                renderGrid: true,
                helperMsg: ''
            }
        },
        methods: {
            scrollWorkaround: function(){
                var vm = this;
                try{
                    var offL = vm.grid.jqxGrid('scrollposition');
                    vm.grid.jqxGrid('scrolloffset', offL.top, offL.left+1);
                    vm.grid.jqxGrid('scrolloffset', offL.top, offL.left);
                }catch(e){}
            },
            overrideGridConfigs: function(){
                if(this.options != null){
                    for (var prop in this.options){
                        this.grid_configs[prop] = this.options[prop];
                    }
                }

                //TODO: MERGE GRID GENERAL CONFIGS!

                if(this.grid_configs.pagesize == "auto"){
                    this.getRowXPage();
                }
                if(this.grid_configs.initrowdetails == "nested"){
                    if(this.others && this.others.nestedinfo && this.others.nestedinfo[1]){
                        var name = this.name;
                        this.grid_configs.rowdetailstemplate.rowdetails = "<div class='nestedWrapper' style='margin: 10px 0px 10px 10px;'><div class='nestedGrid'  id='" + name +"1Nested'></div></div>"
                        this.grid_configs.initrowdetails = this.getNestedDefinition(1, this.source, this.name + "1Nested")
                    } else {
                        this.grid_configs.rowdetails = false;
                        this.grid_configs.initrowdetails = null;
                    }
                }
            },
            mergeThenParseColumns: function(source_columns, source_data, gridName){
                 if(Array.isArray(source_columns)){
                    // mantengo la gestione della proprietà columns.configs col formato direttamente accettato dalla libreria jqwidget (Array)
                    // do nothing
                } else {
                    // ma per la maggior parte delle griglie integrate in aps, il formato della proprietà columns.configs sarà un oggetto
                    // in modo da permettere di eseguire un override delle proprietà da json di configurazione 
                    var mergeConfigs = this.$Components[gridName];
                    mergeConfigs = mergeConfigs == null ? {} : mergeConfigs.columns; 0
                    source_columns = this.mergeColumnsConfigs(source_columns, mergeConfigs);
                }
                return this.parseColumns(source_columns, source_data, gridName);
            },
            // chiamata solo nel caso le colonne siano ri-configurabili (columns.configs come Object e non Array)
            //il valore di return sarà comunque un Array col formato accettato da jqwidget ( passando per parseColumns() )
            mergeColumnsConfigs: function(source_columns, mergeConfigs){
                var columnsArray = [];
                var actualConfigs = source_columns;
                for(var prop in mergeConfigs){ 
                    var col = mergeConfigs[prop] 
                    //overriding column "col"
                    for(var conf in col){
                        switch(conf){
                            // name, visible e width già esistenti di traducono in modo diverso nelle config di jqwidget
                            case 'name':
                                //TODO: da inserire fetching traduzione
                                actualConfigs[prop].text = col.name != false ? this.$Jed.firstUpperTranslate(col.name) : ""; 
                            break;
                            case 'visible':
                                // hidden = false se (visible == true || undefined)
                                actualConfigs[prop].hidden = col.visible == false
                            break;
                            case 'width':
                                // width in config scritto come intero, ma da intendere in percentuale
                                actualConfigs[prop].width = col.width;
                            break;
                            default:
                                // altrimenti, esegue override diretto senza distinzioni
                                actualConfigs[prop][conf] = col[conf];

                        }
                    }
                }
                for(var prop in actualConfigs){
                    columnsArray.push(actualConfigs[prop])
                }
                return columnsArray;
            },
            parseColumns: function(source_columns, source_data, gridName){
                var vm = this;
                /*
                var columnsArray = source_columns.filter(function(obj){
                    return obj.hidden != true;
                });
                */
                var columnsArray = source_columns;
                var columnsDatafields = []
                var vm = this;
                //mapping columns infos
                columnsArray.sort(function(a,b){
                    if(a.position == null){
                        return 1
                    } else if(b.position == null){
                        return -1;
                    } else {
                        return a.position - b.position;
                    }
                })
                for(let i = 0; i < columnsArray.length; i++){
                    //assegno le traduzioni
                    if(columnsArray[i].text) columnsArray[i].text = this.$Jed.firstUpperTranslate(columnsArray[i].text)

                    //building datafieldsdatafields
                    columnsDatafields.push({name: columnsArray[i].datafield, type: columnsArray[i].type})
                    //building cellsrenderers
                    if(columnsArray[i].tobecellsrenderered != null){
                        //uso let, altrimenti custom renderer viene sovrascritto quando renderizzato
                        let customRenderer = columnsArray[i].tobecellsrenderered;
                        columnsArray[i].cellsrenderer = function(row, columnfield, value, defaulthtml, columnproperties){
                            return customRenderer(vm.source[row], row, columnfield, value, defaulthtml, columnproperties);
                        }
                    }
                    //gestione colonna che contiene icone
                    if(columnsArray[i].iconcolumn){
                        //columnsArray[i].text = '' //header delle colonne con icona è vuoto
                        if(columnsArray[i].customicon){
                            columnsArray[i].cellsrenderer = function(row, columnfield, value, defaulthtml, columnproperties){
                                return "<div style='display: table;width: 100%;height: 100%;text-align: center;'>"+
                                        columnsArray[i].setcustomicon(vm.source[row]) +
                                        "</div>";
                            }
                        }else{
                            columnsArray[i].cellsrenderer = function(row, columnfield, value, defaulthtml, columnproperties){
                                return "<div style='display: table;width: 100%;height: 100%;text-align: center;'><i class='" + 
                                columnsArray[i].geticonclass(vm.source[row], row) + " icon-stack-1x'></i></div>";
                            }
                        }
                    }
                    //gestione colonna multi funzione: dentro la funzione costruisco un componente personalizzato
                    if(columnsArray[i].mfncolumn){
                        columnsArray[i].cellsrenderer = function(row, columnfield, value, defaulthtml, columnproperties){
                            return "<div style='display: table;width: 100%;height: 100%;text-align: center;'>"+
                                columnsArray[i].setmfn(vm.source[row], row)+
                                "</div>";
                        }
                    }
                    // overriding for boolean default behaviors
                    if(columnsArray[i].type == 'bool'){
                        columnsArray[i].columntype = 'checkbox'
                        columnsArray[i].filtertype = 'custom';
                        columnsArray[i].createfilterpanel = this.buildBooleanBox;
                    } else if(columnsArray[i].type == "date"){
                        columnsArray[i].filtertype = 'date';
                        if(columnsArray[i].cellsformat == null){
                            columnsArray[i].cellsformat = "dd/MM/yyyy"
                        }
                    }

                    if(columnsArray[i].editable){
                        columnsArray[i].cellclassname = "point";
                    }

                    // mi serve una proprietà nella stuttura dati colonna di jqwGrid per identificare univocamente la colonna in fase di oncolumnclick
                    var dt = new Date().getTime();
                    var columnUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                        var r = (dt + Math.random()*16)%16 | 0;
                        dt = Math.floor(dt/16);
                        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                    });
                    // dato che non sembra essercene alcuna predisposta (datafield e text sono tutti inaffidabili)... 
                    //...concateno l'id nella classe della colonna, in questo modo anche se due colonne hanno applicate le stesse classi css, classname risulterà univoco
                    if(columnsArray[i].classname != null){
                        columnsArray[i].classname += " $"+columnUID;
                    } else {
                        columnsArray[i].classname = "$"+columnUID;
                    }
                    
                    if(columnsArray[i].onclick && !columnsArray[i].editable){
                        this.buildListMenu(columnsArray[i], gridName)
                    }
                }
                //setup oncellclick listener per gestione onclick e contextMenu
                this.setupClickBehavior(gridName, columnsArray, source_data);
                return {columns: columnsArray, datafields: columnsDatafields}
            },
            columnsWidthAdjust: function(){
                var covered = 0;
                //calcolo la percentuale coperta con le colonne visibili
                for(var i = 0; i < this.mappedColumns.length; i++){
                    if(this.mappedColumns[i].hidden != true){
                        try {
                            var n = Number(this.mappedColumns[i].width.split('%')[0]);
                            covered += n;
                        } catch(err) {}
                    }
                }
                // se sono da ricalcolare le percentuali (covered != 100), calcolo le proporzioni
                if(covered != 100 && covered != 0){
                    var covering = 0;// tengo una variabile per non avere problemi d'arrotandomento
                    var visibleMappedColumns = [] //faccio il mapping solo delle colonne visibili
                    this.mappedColumns.forEach((obj)=>{
                        if(!obj.hidden)visibleMappedColumns.push(obj)
                    })
                    for(var i = 0; i < visibleMappedColumns.length - 1; i++){
                        if(visibleMappedColumns[i].hidden != true){
                            try {
                                var n = Number(visibleMappedColumns[i].width.split('%')[0]);
                                var perc = Math.floor(n*100/covered);
                                covering += perc;
                                visibleMappedColumns[i].width = perc + "%";
                            } catch(err) {}
                        }
                    }
                    //usando Math.floor si arrotondano le width quindi rimane una parte scoperta della tabella
                    //allargo l'ultima colonna visibile per riempire lo spazio rimanente della tabella
                    //ho dovuto fare il controllo di quelle visibili creando l'array visibleMappedColumns perchè
                    //se l'ultima non era visibile l'allargamento dell'ultima colonna non serviva a riempire lo spazio rimanente
                    visibleMappedColumns[i].width = (100 - covering) + "%"; 
                    this.mappedColumns = visibleMappedColumns
                }
                
            },
            initSource: function(){
                this.sorgente = {
                    localdata: this.source,
                    datatype: "array",
                    datafields: this.datafields
                }
                this.$nextTick(function(){
                    this.draw();
                });
            },
            draw: function(){
                var dataAdapter = new $.jqx.dataAdapter(this.sorgente);
                this.grid_configs.source = dataAdapter;
                this.grid_configs.columns = this.mappedColumns;
                this.grid.jqxGrid(this.grid_configs);
                this.focusRows();
                this.$nextTick(function(){
                    if(this.sortby){
                        this.grid.jqxGrid("sortby", s[0], s[1]);
                    }
                    this.$emit("ready")
                    this.eventPropagation()
                })
            },
            focusRows: function(){
               this.grid.jqxGrid('clearselection');
                if(this.select != null && this.selectParameter != null){
                    var rows = this.grid.jqxGrid('getrows');
                    if(rows){
                        for(var i = 0; i < rows.length; i++){
                            if(rows[i][this.selectParameter] == this.select){
                                this.grid.jqxGrid('selectrow', rows[i].boundindex);
                            }
                        }
                    }
                }
                var vm = this;
            },
            filterCommand: function(datafield, AndOperator, filtervalue){
                var filtergroup = new $.jqx.filter();
                var filter_or_operator = AndOperator ? 0 : 1;
                var filtercondition = 'contains';
                var filter1 = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);            
                filtergroup.addfilter(filter_or_operator, filter1);
                // add the filters.
                this.grid.jqxGrid('addfilter', datafield, filtergroup);
                // apply the filters.
                this.grid.jqxGrid('applyfilters');
            },
            removeFilterCommand: function(){
                this.grid.jqxGrid('clearfilters');
            },
            getRowXPage: function() {
                var available = window.innerHeight;
                if (this.grid_configs.showheader) {
                    available -= (this.grid_configs.columnsheight * 2);
                    if (this.grid_configs.filterable && this.grid_configs.showfilterrow) {
                        available -= this.grid_configs.filterrowheight;
                    }
                }
                
                if(this.others.offsetPageCalculation){
                    available -= this.others.offsetPageCalculation;
                }
                //20px come margine di errore
                available -= 20;
                //if rowsheight is fixed, / rowsheight
                var rows_x_page = Math.floor(available / this.grid_configs.rowsheight);
                this.grid_configs.pagesize = rows_x_page;
                var opts = [rows_x_page, 5, 10 , 20];
                this.grid_configs.pagesizeoptions = opts.sort(function(a,b){
                    return a - b;
                });
            },
            getSelectedRows: function(){
                return this.grid.jqxGrid('getselectedrowindexes');
            },
            forcedRedraw: function() {
                //metodo per forzare l'aggiornamento, nei caso il cambiamento dei dat sorgenti non venga identificato dal componente 
                this.sorgente.localdata = this.source;
                this.grid.jqxGrid('updatebounddata');
                this.grid.jqxGrid('clearselection');
                this.focusRows();
            },
            eventPropagation: function(){
                var vm = this;
                // da inserire man mano gli eventi che si vuole intercettare nella sopra classe
                this.grid.off('rowselect');
                this.grid.on('rowselect', function (event) {
                    vm.$emit('jqxGridEvent', {name: 'rowselect', event: event});
                });

                this.grid.off('cellendedit');
                this.grid.on('cellendedit', function (event) {
                    // inoltro l'evento di cell edit
                    // delego al componente padre di eseguire il mapping delle modifiche, in quanto non posso sapere a priori la relazione fra tipo dato iniziale e quello dichiarato nella configurazione colonne
                    // a monte potrebbe essere necessario eseguire uno switch su 'event.datafield' e mappare caso per caso
                    vm.$emit('jqxGridEvent', {name: 'cellendedit', event: event});
                });

                this.grid.off('rowexpand');
                this.grid.on('rowexpand', function (event) {
                    vm.$emit('jqxGridEvent', {name: 'rowexpand', event: event});
                });

                var grr = this.grid;
                var gate = false;

                grr.off("sort")
                grr.on('sort', function (event) {
                    // event arguments.
                    var args = event.args;
                    // sorting information.
                    var sortInfo = event.args.sortinformation;
                    // sort direction.
                    var sortdirection = sortInfo.sortdirection.ascending ? "ascending" : "descending";
                    // column data field.
                    var sortColumnDataField = sortInfo.sortcolumn;
                    if(gate == true){
                        gate = false;
                    } else {
                        try {
                            var c = vm.columns.configs[sortColumnDataField];
                            if(c && c.sortBy != null){
                                gate = true;
                                console.log("SORTING BY " + c.sortBy) 
                                console.log(vm.source)
                                console.log(sortdirection)
                                grr.jqxGrid('sortby', sortColumnDataField, sortdirection, null, null, null, c.sortBy);
                            }

                        } catch(err){
                            console.log(err)
                        }
                    }
                    
                });
            },
            buildBooleanBox: function(datafield, fatherPanel) {
                var vm = this;
                var container = $('<div style="margin: 10px 0px 15px 3px;">' + this.grid_configs.localization.filtershowrowstring + '</div>');
                var checkbox = $('<div id="filtercheckbox" style="margin-left: 10px; display: inline-block;"></div>');
                container.append(checkbox)
                fatherPanel.append(container);
                $("#filtercheckbox").jqxCheckBox({
                    width: 120,
                    theme: vm.grid_configs.theme
                });

                var applyInput = $("<div class='filter' style='height: 25px; margin-left: 0px; margin-top: 7px;'></div>");
                fatherPanel.append(applyInput);
                var filterbutton = $('<span id="apply_filter_button" tabindex="0" style="padding: 4px 12px; margin-left: 2px;">' + this.grid_configs.localization.filterstring + '</span>');
                applyInput.append(filterbutton);
                var filterclearbutton = $('<span tabindex="0" style="padding: 4px 12px; margin-left: 5px;">' + this.grid_configs.localization.filterclearstring + '</span>');
                applyInput.append(filterclearbutton);

                filterbutton.jqxButton({
                    theme: vm.grid_configs.theme,
                    height: 20
                });
                filterclearbutton.jqxButton({
                    theme: vm.grid_configs.theme,
                    height: 20
                });

                //applico effettivamente il filtro
                filterbutton.on('click', function () {
                    // ??? il click trigghera comunque anche se il button è disabilitato ???
                    if (!filterbutton.jqxButton("disabled")) {
                        var filtergroup = new $.jqx.filter();
                        var filter_or_operator = 1;
                        var filtervalue = checkbox.jqxCheckBox('val');
                        // filtercondition passata come parametro dalla dropbox selection
                        var filtercondition = filtervalue ? 'equal' : 'not_equal';
                        var filter = filtergroup.createfilter('booleanfilter', true, filtercondition);
                        filtergroup.addfilter(filter_or_operator, filter);

                        $(vm.grid).jqxGrid('addfilter', datafield, filtergroup);
                        $(vm.grid).jqxGrid('applyfilters');
                        $(vm.grid).jqxGrid('closemenu');
                    }
                });
                filterbutton.keydown(function (event) {
                    if (event.keyCode === 13) {
                    filterbutton.trigger('click');
                    }
                });
                filterclearbutton.click(function () {
                    $(vm.grid).jqxGrid('removefilter', datafield);
                    checkbox.jqxCheckBox('val', false);
                    // apply the filters.
                    $(vm.grid).jqxGrid('applyfilters');
                    $(vm.grid).jqxGrid('closemenu');
                });
                filterclearbutton.keydown(function (event) {
                    if (event.keyCode === 13) {
                    filterclearbutton.trigger('click');
                    }
                    checkbox.jqxCheckBox('val', false);
                });
            },
            //funzione ricorsiva per definire l'initrowdetails() delle griglie innestate
            getNestedDefinition: function(step, source_data){
                //nested info object - a qeusto punto sono sicuro che esiste ed è != null
                var nio = this.others.nestedinfo[step];
                var vm = this;
                var originalHeight = nio.options.height;

                return function(index, parentElement, gridElement, record){
                    // il riferimento al sorgente mi serve per poter usufruire dell'intero record sorgente in fase di getRecordCallback
                    var record_set = nio.getRecordsCallback(index, record, source_data[index]);
                    var nameGrid = vm.name + step + "Nested";
                    var res = vm.mergeThenParseColumns(nio.columns, record_set, nameGrid)
                    var nested_grid = $(parentElement).find("#"+ nameGrid);
                    var nested_source = {
                        id: 'nestedGrid' + step,
                        datafields: res.datafields,
                        localdata: record_set
                    }
                    var nestedGridAdapter = new $.jqx.dataAdapter(nested_source);

                    if (nested_grid != null) {
                        var overall_configs = nio.options;
                        overall_configs.columns = res.columns;
                        overall_configs.source = nestedGridAdapter;
                        //eredito la lingua dalla grid principale
                        overall_configs.localization = vm.grid_configs.localization;

                        var next = step + 1;
                        var nextNameGrid = vm.name + next + "Nested";
                        if(vm.others.nestedinfo[next]){
                            overall_configs.rowdetails = true;
                            overall_configs.rowdetailstemplate =  {
                                rowdetails: "<div class='nestedWrapper' style='margin: 10px 0px 10px 10px;'><div class='nestedGrid' id='" + nextNameGrid + "'></div></div>",
                                rowdetailsheight: nio.rowdetailsheight ? nio.rowdetailsheight : 150 
                            };
                            overall_configs.initrowdetails = vm.getNestedDefinition(next, record_set);
                        } else {
                            overall_configs.rowdetails = false;
                        }
                        
                        // calcolo appropriatamente l'altezza della griglia innestata considerando diversi fattori
                        overall_configs.pagesize = 5;
                        //forzo numero elementi per pagina, così posso nascondere la selezione a tendina che bugga nella grigle innestate
                        if(overall_configs.autoheight != true) {
                            overall_configs.autoheight = false;
                            var h = vm.calcGridHeight(overall_configs, originalHeight, nested_source.localdata.length);
                            overall_configs.height = h;
                        }
                        nested_grid.jqxGrid(overall_configs);

                        // definisco refresh on resize anche per le nested grids 
                        $(window).resize(function() {
                            // chiamo la funzione di refresh per fixare il bug di resize della grid
                            nested_grid.jqxGrid('refresh');
                        });
                        eventBus.$on("containerResize", function(){
                            nested_grid.jqxGrid('refresh');
                        })
                    }

                }
            },
            calcGridHeight: function(conf, originalHeight, itemsLength){
                // definizione fattori
                var headers_height, pager_height, rows_height, pagesize;
                var min_table, min_page;
                // valori indicati da config, o default della libreria
                headers_height = conf.columnsheight ? conf.columnsheight : 30;
                pager_height = conf.pagerheight ? conf.pagerheight : 35;
                var offset = headers_height + pager_height;

                rows_height = conf.rowsheight ? conf.rowsheight : 28;
                pagesize = conf.pagesize ? conf.pagesize : 10;

                min_table = (itemsLength * rows_height) + offset;
                min_page = (pagesize * rows_height) + offset;
                
                var detailsMin = conf.rowdetails ? 200 : 0;
                // Minimo fra valore definito, altezza pagina intera, altezza tabella intera, il tutto se maggiore di 200px (minimo di spazio per ulteriori dettagli)
                return Math.max(Math.min(originalHeight, Math.min(min_table, min_page)), detailsMin);
                //come height definita, uso quella passata come prop in nested_info config, che sono sicuro non sia stata sovrascritta
            },
            buildListMenu: function(column, name) {
                var vm = this;
                if (Array.isArray(column.onclick)) {
                    var id = name + "_context_" + column.datafield;

                    var cont = document.createElement("DIV");
                    cont.className = "popup_build";
                    cont.id = id;
                    var ul = document.createElement("UL");
                    for (let i = 0; i < column.onclick.length; i++) {
                        var li = document.createElement("LI");
                        var a = document.createElement("A");
                        var t = document.createTextNode(column.onclick[i].text);
                        a.appendChild(t);
                        li.appendChild(a);
                        ul.appendChild(li);
                        
                        li.addEventListener("click", function (e) {
                            e.preventDefault();
                            if (vm.active_row) {
                                // l'indice i ha uno scope coerente perchè uso let nel for loop
                                column.onclick[i].exec(vm.active_row)
                            }
                        });
                    }
                    cont.appendChild(ul);
                    document.body.appendChild(cont);
                    column.contextMenu = $("#" + id).jqxMenu({
                        autoOpenPopup: false,
                        mode: 'popup',
                        theme: this.grid_configs.theme
                    }); 
                    // disable the default browser's context menu.
                    $(document).bind('contextmenu', function (e) {
                        return false;
                    });
                }
            },
            setupClickBehavior: function(gridName, columns, source_data){
                var vm = this;
                var grid = $("#" + gridName);

                grid.off("cellclick") // rimuovo eventuali binding precedenti
                grid.on("cellclick", function (event) {
                    // event arguments.
                    var args = event.args;
                    // row's bound index.
                    var rowBoundIndex = args.rowindex;
                    // row's visible index.
                    var rowVisibleIndex = args.visibleindex;
                    // right click.
                    var rightclick = args.rightclick;
                    // original event.
                    var ev = args.originalEvent;
                    // column.
                    var columnObject = args.column;
                    // column index.
                    var columnindex = args.columnindex;
                    // cell value
                    var value = args.value;

                    var data_row = source_data[rowBoundIndex];
                    
                    var column;
                    //estraggo la colonna esatta di riferimento (non posso usare column_index, l'info non è coerente se ho aggiunto per esempio la colonna dei checkbox o dei dettagli)
                    columns.some(function (obj) {
                        // doppio confronto per datafield e header label
                        if (obj.classname == columnObject.classname ) {
                            column = obj;
                            return true;
                        }
                        return false;
                    })
                    
                    if (column) {
                        if( column.editable){
                            vm.leftPos = args.originalEvent.clientX;
                            vm.topPos = args.originalEvent.clientY;
                            if(value){
                                if(value.includes('>')){
                                    var v = value.split('>')
                                    vm.initialValue = v[v.length-1];
                                }else{
                                    vm.initialValue = value;
                                }
                            }
                            vm.validation = column.validation;

                            if(column.editPopupCfg){
                                vm.popupTitle = column.editPopupCfg.title
                                vm.popupContent = column.editPopupCfg.content + '<a style="font-weight: bold;">'+data_row.cod+'</a>'
                                vm.popoverCondition = column.editPopupCfg.popCond
                                vm.popoverStyle = column.editPopupCfg.popStyle
                                vm.arrowStyle = column.editPopupCfg.arrStyle
                            }

                            var triggering = null;
                            if(column.selectionEditMode){
                                triggering = "selectionPopup"
                                vm.editSelectOptions = column.selectionEditChoices ? column.selectionEditChoices : [];
                            } else {
                                switch(column.type){
                                    case "number":
                                    triggering = "numberPopup";
                                    break;
                                    case "date": 
                                    triggering = "datePopup"
                                    break;
                                    default:
                                    triggering = "textPopup"
                                }
                            }
                            vm.editEndCallback = function(res){
                                data_row[column.datafield] = '<i class="icon-modificare"> </i>'+res;
                                vm.grid.jqxGrid('updatebounddata', 'data');
                                if(column.editPopupCfg.ex){
                                    column.editPopupCfg.ex(data_row, res)
                                }
                            }
                            vm.triggerEditor(triggering);
                            //generate guid and click on nextTick
                            var dt = new Date().getTime();
                            vm.guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                                var r = (dt + Math.random()*16)%16 | 0;
                                dt = Math.floor(dt/16);
                                return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                            });
                            vm.$nextTick(function(){
                                $("#"+vm.guid).click();
                            })
                            
                        } else if( column.onclick){
                            if (!Array.isArray(column.onclick)) {
                                column.onclick(data_row, ev, rowBoundIndex);
                            } else {
                                vm.active_row = data_row;

                                if (column.contextMenu) {
                                    var scrollTop = $(window).scrollTop();
                                    var scrollLeft = $(window).scrollLeft();
                                    var x = parseInt(ev.clientX) + scrollLeft;
                                    var y;
                                    if (Math.ceil(grid.jqxGrid('pagesize') / rowVisibleIndex) == 2) {
                                        //se la riga cliccata si trova nella seconda metà (in verticale, considerando il numero di righe per pagina)
                                        //per essere sicuro che il dropdown non sfori la tabella, allineo la y più in alto in base al numero di voci nel menu * 25
                                        y = parseInt(ev.clientY) + scrollTop - (25 * column.onclick.length)
                                    } else {
                                        y = parseInt(ev.clientY) + scrollTop
                                    }

                                    column.contextMenu.jqxMenu('open', x, y);
                                    return false;
                                }
                            }
                        }
                    }

                    if(gridName == vm.name){
                        vm.rowClick(data_row, rowBoundIndex);
                    }else{ //se tabella innestata, applico una funzione di rowclick specifica, dichiarata nelle nestedinfo della tabella innestata
                        var split1 = gridName.split('Nested')[0]
                        var nested_id = split1[split1.length - 1]
                        var rowClickFn = vm.others.nestedinfo[nested_id].rowClick
                        if(rowClickFn != null){
                            rowClickFn(data_row, rowBoundIndex)
                        }
                    }

                    
                });
                grid.off("columnclick") // rimuovo eventuali binding precedenti
                grid.on("columnclick", function (event) {
                    // event arguments.
                    var args = event.args;
                    // column's settings.
                    var column = args.column;
                    if(vm.$root.help){
                        
                        var found = null;
                        vm.mappedColumns.some(function(c){
                            if(c.classname == column.classname){
                                found = c;
                                return true;
                            }
                            return false;
                        })
                        if(found && found.tooltip){
                            if(found.tooltip){
                                var sameAsPrev = vm.helperMsg == found.tooltip
                                vm.helperMsg = found.tooltip;
                                var vis = vm.$root.trigger_help(vm.name);
                                if(!vis && !sameAsPrev){
                                    vm.$root.trigger_help(vm.name);
                                }
                            }
                        }
                    }
                })

            },
            triggerEditor: function(field){
                this.textPopup = false;
                this.selectionPopup = false;
                this.numberPopup = false;
                this.datePopup = false;
                this[field] = true;
            }
        }
    }
</script>
<style>
    /*   set auto height per i menu (e figli) di colonna per filtri e ordinamento   */
    .jqx-menu.jqx-widget-content.jqx-popup {
        height: auto !important;
    }
    .jqx-menu.jqx-widget-content.jqx-popup li {
        height: auto !important;
    }

    /* elimina margine sinistro nei dettagli della riga */
    div.jqx-grid-content.jqx-widget-content > .jqx-widget-content {
        margin-left: 0px !important;
    }

    /* griglie ricorsive scrollabili */
    .nestedGrid {
        width: calc(100% - 8px) !important;
    }

    /* pager popup e label sempre nascosti nelle liste innestate*/
    .nestedGrid .jqx-grid-pager.jqx-widget-header .jqx-dropdownlist-state-normal,
    .nestedGrid .jqx-grid-pager.jqx-widget-header .jqx-dropdownlist-state-normal + div {
        display: none !important;
    }

    ul.jqx-menu-ul {
        width: max-content
    }

    .jqx-menu li {
        display: none;
    }

    .point {
        cursor: pointer
    }
</style>


// WEBPACK FOOTER //
// src/components/dynamic/jqwGridWrapper/jqwGridWrapper.vue?28206212